export type ContactView = 'landing' | 'form' | 'confirmation' | 'success';

export interface ContactFormData {
  name: string;
  email: string;
  reason: string;
  message: string;
}

export interface ContactFormErrors {
  name?: string;
  email?: string;
  reason?: string;
  message?: string;
}

export const INITIAL_FORM_DATA: ContactFormData = {
  name: '',
  email: '',
  reason: '',
  message: '',
};
